import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=e5611ef6&scoped=true"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=e5611ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5611ef6",
  null
  
)

export default component.exports